import { prefixerC } from '.'

export const ROUTE_APROBACION_CONTABLE_SERVICIOS = prefixerC('aprobacion-contable-servicios')
export const ROUTE_APROBACION_TRIBUTARIA_SERVICIOS = prefixerC('aprobacion-tributaria-servicios')
export const ROUTE_DUENO_CATEGORIA = prefixerC('dueno-categoria')
export const ROUTE_NIVEL_APROBACION = prefixerC('nivel-aprobacion-solicitud')
export const ROUTE_PERMISOS_CATEGORIA = prefixerC('permisos-categoria')
export const ROUTE_RESPONSABLES_APROBACION_OC = prefixerC('responsables-aprobacion-oc')
